import script from "./PricingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingSection.vue?vue&type=script&setup=true&lang=js"

import "./PricingSection.vue?vue&type=style&index=0&id=43e3f2cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43e3f2cc"]])

export default __exports__